module.exports = __webpack_public_path__ + "img/Fachzug_Logistik.a7aaaae3.svg";